import React from 'react'
import './dropdown.css';
import { ErrorMsg } from '../error-message';
import { useFormContext } from 'react-hook-form';
function Dropdown({
    id = "",
    name = "",
    options = [],
    raised = false,
    small = false,
    className = "",
    big = false,
    fluid = false,
    placeholder = '',
}) {

    const { register, formState: { errors } } = useFormContext()

    return <div>
        <select

            id={id}
            {...register(name)}
            className={`${className} dropdown ${raised ? "raised" : ""} ${small ? "small" : ""} ${big ? "big" : ""} ${fluid ? "fluid" : ""} ${errors[name] ? "invalid" : ""}`} >
            <option value="" key="dropdown_1">{placeholder}</option>
            {options.map((element, i) => <option key={`element_${i}`} value={element.value}>
                {element.label}
            </option>)}
        </select>
        <ErrorMsg errors={errors} name={name} darkMode />
    </div>
}
export default React.memo(Dropdown); 